module.exports = __webpack_public_path__ + "static/media/DailyPostcard.b7701148.png";